<script lang="ts">
  import type { Writable } from 'svelte/store'
  import { persisted } from 'svelte-persisted-store'
  
  import MobileMenu from '../MobileMenu.svelte'
  import { teleport } from '../../../../util'

  export let mobileMenuVizStore: Writable<boolean>
  let currentDepartment = undefined
  export let desktopMenu: Element|undefined
  export let departmentMenu: Element|undefined

  export let pathChunks: any

  // export let divisionsMainMenuVizStore: any
  // export let isDivision: any
  // export let desktopSearchVizStore: any

  let departmentHomeItemIndex: number|undefined = undefined
  let departmentHomeItem: object
  
  let menu = []
  let departmenu = []
  const cachedMenu = persisted('cached-extracted-menu', [])

  // extract the menu
  $: if(desktopMenu) {
    const clonedMenu = desktopMenu.cloneNode(true)

    for (let i = 0; i < clonedMenu.children.length; i++) {
      const item = clonedMenu.children.item(i)
      const a = item?.querySelector('a')
      
      const obj = {
        Title: a?.innerText,
        Url: a?.href,
      }

      const submenu = item?.querySelector('.submenu-wrapper > ul')

      // console.log('submenu', submenu)

      if(submenu) {
        const children = []

        for(let i = 0; i < submenu.children.length; i++) {
          const subItem = submenu.children.item(i)
          const subA = subItem.querySelector('a')
          
          children.push({
            Title: subA?.innerText,
            Url: subA?.href,
          })
        }

        obj.ChildNodes = children
      }

      // menu.push(obj)
      menu = [...menu, obj]
    }

   // console.log('menu', menu)
  } else {
    // populate/refresh the cached menu if we get one
    // probably not necessary for environments that aren't affected by HTTPClient timeouts...
    cachedMenu.set(menu)
    //console.log('cachedMenu', $cachedMenu)
  }
  $: if(departmentMenu) {
    const clonedMenu = departmentMenu.cloneNode(true)

    for (let i = 0; i < clonedMenu.children.length; i++) {
      const item = clonedMenu.children.item(i)
      const a = item?.querySelector('a')
      
      const obj = {
        Title: a?.innerText,
        Url: a?.href,
      }

      const submenu = item?.querySelector('.dropdown > ul')

      //console.log('depart submenu', submenu)

      if(submenu) {
        const children = []

        for(let i = 0; i < submenu.children.length; i++) {
          const subItem = submenu.children.item(i)
          const subA = subItem.querySelector('a')
          
          children.push({
            Title: subA?.innerText,
            Url: subA?.href,
          })
        }

        obj.ChildNodes = children
      }

      // menu.push(obj)
      departmenu = [...departmenu, obj]
    }

    //console.log('depart menu', departmenu)
  } else {
    // populate/refresh the cached menu if we get one
    // probably not necessary for environments that aren't affected by HTTPClient timeouts...
    cachedMenu.set(departmenu)
    //console.log('cachedMenu', $cachedMenu)
  }

  $: allDepartmentsMenu = menu ? menu.find((_)=> {
    if(_) return _.Title === 'Departments'
  }) : undefined

  // doing stuff if we're on a department page
  $: if($pathChunks[0] === 'depart' && allDepartmentsMenu && menu && menu.length > 0) {
    // currentDepartment = allDepartmentsMenu.ChildNodes.find((_)=> {
    //   const urlMatch = _.Url === `/${$pathChunks[0]}/${$pathChunks[1]}`
    //   if(urlMatch) {
    //     return _
    //   }
    // })
  }
</script>

{#if $mobileMenuVizStore}
  <div class="mobile-menu-modal-actual" class:mobile-menu-visible={$mobileMenuVizStore} use:teleport>
    <MobileMenu menu={menu.length > 0 ? menu : $cachedMenu} {pathChunks} {currentDepartment} currentDepartmentMenu={departmenu} {departmentHomeItem} />
  </div>
{/if}

<style lang="scss">
  .mobile-menu-modal-actual {
    @media (min-width: 1385px) {
      display: none;
    }
  }
</style>